<template>
  <section>
    <breadcrumbs></breadcrumbs>
    <!-- 查询条件 -->
    <el-form
      ref="searchForm"
      :model="searchForm"
      label-width="100px"
      inline
      class="demo-form-inline"
      size="small"
      style="border-bottom: 1px solid var(--table-border);"
    >
      <el-form-item label="角色名称" prop="name">
        <el-input
          v-model="searchForm.name"
          placeholder="请输入角色名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="find">查询</el-button>
        <el-button @click="chong">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- <btns @exec="exec"></btns> -->
    <el-button
      type="primary"
      class="mgt-20"
      @click="$router.push('/sys/role/roleAdd')"
      >新增</el-button
    >
    <div class="data-container scroll-table mgt-20">
      <!-- 角色列表 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="roleName" label="角色名称"> </el-table-column>
        <el-table-column prop="roleTypeNameList" label="角色场景">
        </el-table-column>
        <el-table-column prop="addTime" label="创建时间"> </el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              @click.native="handleEdit(scope.row)"
              type="text"
              size="small"
              >编辑</el-button
            >
            <el-button
              type="text"
              size="small"
              @click.native="handleDel(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--新增修改界面-->
  </section>
</template>

<script>
import btns from "@/components/btns.vue";
import breadcrumbs from "@/components/breadcrumbs.vue";
import { handleConfirm, handleAlert } from "../../utils/UtilsIf";
export default {
  components: {
    btns,
    breadcrumbs,
  },
  data() {
    return {
      searchForm: {
        name: "",
      },
      tableData: [],
      roleType: "",
    };
  },
  created() {
    this.getlist();
  },

  methods: {
    getlist() {
      this.$api.role.rolelist().then((res) => {
        if (res.code === 200) {
          //1景区，2校园，3社区
          res.data.forEach((element) => {
            if (element.roleType) {
              element.roleTypeNameList = element.roleType
                .split(",")
                .map((data) => {
                  return data == 1
                    ? "景区场景"
                    : data == 2
                    ? "校园场景"
                    : data == 3
                    ? "社区场景"
                    : "";
                })
                .toString();
            }
          });
          this.tableData = res.data;
        }
      });
    },

    // 查询
    find() {
      this.$api.role
        .findRole({ roleName: this.searchForm.name })
        .then((res) => {
          if (res.code === 200) {
            //1景区，2校园，3社区
            res.data.forEach((element) => {
              if (element.roleType) {
                element.roleTypeNameList = element.roleType
                  .split(",")
                  .map((data) => {
                    return data == 1
                      ? "景区场景"
                      : data == 2
                      ? "校园场景"
                      : data == 3
                      ? "社区场景"
                      : "";
                  })
                  .toString();
              }
            });
            this.tableData = res.data;
          }
        });
    },
    chong() {
      this.searchForm = {};
      this.getlist();
    },

    handleEdit(row) {
      console.log(row);
      this.$router.push({
        path: "/sys/role/roleEdit",
        query: {
          roleName: row.roleName,
          roleTypeName: row.roleTypeNameList,
          roleType: row.roleType,
          roleId: row.roleId,
          serverId: row.serverId ? row.serverId : "",
        },
      });
    },

    // 删除角色
    handleDel(row) {
      handleConfirm("确认删除该角色吗？", "info")
        .then(() => {
          this.$api.role.delRole({ roleId: row.roleId }).then((res) => {
            if (res.code === 200) {
              handleAlert("角色已删除", "success");
              this.getlist();
            }
          });
        })
        .catch(() => {
          handleAlert("删除取消", "error");
        });
    },

    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
  },
};
</script>
